import CampPageWrapper from './Views/CampWrapper/CampPageWrapper'
import CategoryPageWrapper from './Views/CategoryWrapper/CategoryPageWrapper'
import ClaimPageWrapper from './Views/ClaimWrapper/ClaimPageWrapper'
import ClaimUserPageWrapper from './Views/ClaimUserWrapper/ClaimUserPageWrapper'
import ClientPageWrapper from './Views/ClientWrapper/ClientPageWrapper'
import CompanyPageWrapper from './Views/CompanyWrapper/CompanyPageWrapper'
import ContractorPageWrapper from './Views/ContractorWrappper/ContractorPageWrapper'
import EnterprisePageWrapper from './Views/EnterpriseWrapper/EnterprisePageWrapper'
import EmailTemplatePageWrapper from './Views/EmailTemplateWrapper/EmailTemplatePageWrapper'
import ExportDataPageWrapper from './Views/ExportDataWrapper/ExportDataPageWrapper'
import OptionPageWrapper from './Views/OptionWrapper/OptionPageWrapper'
import ParametersPageWrapper from './Views/ParametersWrapper/ParametersPageWrapper'
import ParamsPageWrapper from './Views/ParamsWrapper/ParamsPageWrapper'
import RangeParametersPageWrapper from './Views/RangeParametersWrapper/RangeParametersPageWrapper'
import PersonPageWrapper from './Views/PersonWrapper/PersonPageWrapper'
import ProfilePageWrapper from './Views/ProfileWrapper/ProfilePageWrapper'
import SitePageWrapper from './Views/SiteWrapper/SitePageWrapper'
import StartPageWrapper from './StartPageWrapper'
import UserPageWrapper from './Views/UserWrapper/UserPageWrapper'
import ConfigDocumentPageWrapper from './Views/ConfigDocumentWrapper/ConfigDocumentPageWrapper'
import ConfigFacturationPageWrapper from './Views/ConfigFacturationWrapper/ConfigFacturationPageWrapper'

export const ListWrappers = {
  camp: <CampPageWrapper />,
  category: <CategoryPageWrapper />,
  claim: <ClaimPageWrapper />,
  'claim-user': <ClaimUserPageWrapper />,
  client: <ClientPageWrapper />,
  company: <CompanyPageWrapper />,
  contract: <ContractorPageWrapper />,
  emailtemplate: <EmailTemplatePageWrapper />,
  enterprise: <EnterprisePageWrapper />,
  'export-data': <ExportDataPageWrapper />,
  option: <OptionPageWrapper />,
  parameters: <ParametersPageWrapper />,
  params: <ParamsPageWrapper />,
  rangeparams: <RangeParametersPageWrapper />,
  person: <PersonPageWrapper />,
  profile: <ProfilePageWrapper />,
  start: <StartPageWrapper />,
  site: <SitePageWrapper />,
  user: <UserPageWrapper />,
  'config-document': <ConfigDocumentPageWrapper />,
  'config-facturation': <ConfigFacturationPageWrapper />,
} as any

export const renderPanelContent = (key: string | undefined) => {
  let component = <></>
  if (key) {
    component = ListWrappers[key]
  }
  return component
}
